"use strict";

exports.__esModule = true;
var CertificateType;

(function (CertificateType) {
  CertificateType["Iron"] = "iron";
  CertificateType["Cloud"] = "cloud";
})(CertificateType = exports.CertificateType || (exports.CertificateType = {}));

var OIDs;

(function (OIDs) {
  OIDs["CRYPTO_PRO_LIMITED_LICENSE"] = "1.2.643.2.2.49.2";
  OIDs["CONTUR_CLOUD_CRYPT"] = "1.2.643.3.7.7.1";
  OIDs["XCN_OID_CRL_DIST_POINTS"] = "2.5.29.31";
  OIDs["XCN_OID_AUTHORITY_KEY_IDENTIFIER2"] = "2.5.29.35";
  OIDs["OWNER_DS_TOOL"] = "1.2.643.100.111";
  OIDs["UC_ISSUER_DS_TOOL"] = "1.2.643.100.112";
})(OIDs = exports.OIDs || (exports.OIDs = {}));

var DecryptErrorMessages;

(function (DecryptErrorMessages) {
  DecryptErrorMessages["CancelTokenInput"] = "[0x8010006E]CryptAcquireCertificatePrivateKey";
  DecryptErrorMessages["CancelPinInput"] = "[0x8010006E]CryptImportKey";
  DecryptErrorMessages["WrongPin"] = "[0x8010006B]CryptImportKey";
})(DecryptErrorMessages = exports.DecryptErrorMessages || (exports.DecryptErrorMessages = {}));

var DecryptErrors;

(function (DecryptErrors) {
  DecryptErrors["CancelTokenInput"] = "CancelTokenInput";
  DecryptErrors["CancelPinInput"] = "CancelPinInput";
  DecryptErrors["WrongPin"] = "WrongPin";
  DecryptErrors["NoSecretKeyContainer"] = "NoSecretKeyContainer";
})(DecryptErrors = exports.DecryptErrors || (exports.DecryptErrors = {}));

var PublicKeyAlgorithm;

(function (PublicKeyAlgorithm) {
  PublicKeyAlgorithm["GOSTR3410_94"] = "1.2.643.2.2.20";
  PublicKeyAlgorithm["GOSTR410_2001"] = "1.2.643.2.2.19";
  PublicKeyAlgorithm["GOSTR3410_2012_256"] = "1.2.643.7.1.1.1.1";
  PublicKeyAlgorithm["GOSTR3410_2012_512"] = "1.2.643.7.1.1.1.2";
})(PublicKeyAlgorithm = exports.PublicKeyAlgorithm || (exports.PublicKeyAlgorithm = {}));